import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../../webcomponents.constants';
import { XdrSearchResultsPanelBaseDataProvider } from '../dataProvider/XdrSearchResultsPanelBaseDataProvider';

export class GlobalExclusionsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, XdrSearchResultsPanelBaseDataProvider);
  }
}
